<script>
    export default {
        props: {
            windowOpen: {
                type: Boolean
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                selectedMediaData: [],
                tree: null,
                selectedTreeItems: [],
            }
        },
        computed: {
            mediaSelected: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
        },
        watch: {
            windowOpen: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (newValue) {
                        this.loadData();

                        this.$nextTick(() => {
                            $(this.$refs.editMediaFlags).on('hidden.bs.modal', () => {
                                this.close();
                            }).modal('show');
                        });
                    } else if (oldValue) {
                        $(this.$refs.editMediaFlags).modal('hide');
                        scoopOS.deselectAll('medias');

                        this.$nextTick(() => {
                            window.location.reload();
                        });
                    }
                },
            }
        },
        methods: {
            loadData() {
                axios.get(Scoop.baseUrl + '/component/media-flag').then((response) => {
                    this.selectedMediaData = response.data.selectedMediaData;
                }).catch((error) => {
                    toastr.error(error, 'Could not load data', {timeOut: 5000});
                    console.log(error);
                });
            },
            storeData(data) {
                axios.post(Scoop.baseUrl + '/component/media-flag', {data: data}).then(() => {
                    toastr.success('Data has been saved');
                    this.loadData();
                }).catch((error) => {
                    toastr.error(error, 'Could not store data', {timeOut: 5000});
                    console.log(error);
                });
            },
            close() {
                this.$emit('close');
            },
            toggleDiscontinued(media) {
                media.discontinued_flag = !media.discontinued_flag;

                this.storeData([media]);
            },
            toggleEcom(media) {
                media.ecom_flag = !media.ecom_flag;

                this.storeData([media]);
            },
            checkAllDiscontinued() {
                _.each(this.selectedMediaData, (media) => {
                    media.discontinued_flag = 1;
                });

                this.$nextTick(() => {
                    this.storeData(this.selectedMediaData);
                });
            },
            checkAllEcom() {
                _.each(this.selectedMediaData, (media) => {
                    media.ecom_flag = 1;
                });

                this.$nextTick(() => {
                    this.storeData(this.selectedMediaData);
                });
            },
            removeAllDiscontinued() {
                _.each(this.selectedMediaData, (media) => {
                    media.discontinued_flag = 0;
                });

                this.$nextTick(() => {
                    this.storeData(this.selectedMediaData);
                });
            },
            removeAllEcom() {
                _.each(this.selectedMediaData, (media) => {
                    media.ecom_flag = 0;
                });

                this.$nextTick(() => {
                    this.storeData(this.selectedMediaData);
                });
            },
        },
    }
</script>
<template>
    <div ref="editMediaFlags" class="modal inmodal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Edit flags</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="m-b-xs">
                                        <i class="fa fa-clock-o"></i>
                                        <span>Discontinued articles</span>
                                        <div class="btn-group" role="group" aria-label="Discontinued articles">
                                            <button type="button" class="btn btn-xs btn-danger"
                                                    @click="checkAllDiscontinued">Check all
                                            </button>
                                            <button type="button" class="btn btn-xs btn-default"
                                                    @click="removeAllDiscontinued">
                                                Remove all
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!--
                                <div class="col-sm-6 text-right">
                                    <div class="m-b-xs">
                                        <i class="fa fa-desktop"></i>
                                        <span>eCom-Daten</span>
                                        <div class="btn-group" role="group" aria-label="eCom-Daten">
                                            <button type="button" class="btn btn-xs btn-success"
                                                    @click="checkAllEcom">Check all
                                            </button>
                                            <button type="button" class="btn btn-xs btn-default"
                                                    @click="removeAllEcom">Remove all
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                -->
                            </div>
                            <ul class="list-group m-b-none">
                                <li class="list-group-item" v-for="media in selectedMediaData">
                                    <div class="row" style="line-height: 64px">
                                        <div class="col-sm-8">
                                            <img :src="media.previewImageUrl" class="img-md img-thumbnail"
                                                 :alt="media.filename">
                                            <strong class="m-l">{{ media.filename }}</strong>
                                        </div>
                                        <div class="col-sm-4 text-right">
                                            <a class="btn btn-sm"
                                               :class="media.discontinued_flag ? 'btn-danger' : 'btn-white'"
                                               @click="toggleDiscontinued(media)">
                                                <i class="fa fa-clock-o"></i>
                                            </a>
                                            <!--
                                            <a class="btn btn-sm"
                                               :class="media.ecom_flag ? 'btn-success' : 'btn-white'"
                                               @click="toggleEcom(media)">
                                                <i class="fa fa-desktop"></i>
                                            </a>
                                            -->
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="pull-left">
                        <button type="button" class="btn btn-white" data-dismiss="modal"
                                v-text="__('scoop-pr.general.close')"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
